import IconPayOff from '@/assets/fonts/system-font/webfonts/icon-pay-off.svg'
import IconPayOffInN from '@/assets/fonts/system-font/webfonts/icon-pay-off-in-n.svg'
import IconPayDown from '@/assets/fonts/system-font/webfonts/icon-pay-down.svg'
import { DataType } from '@/util/index'
// const IconPayOff = '/static/fonts/system-font/webfonts/icon-pay-off.svg'
// const IconPayOffInN = '/static/fonts/system-font/webfonts/icon-pay-off-in-n.svg'
// const IconPayDown = '/static/fonts/system-font/webfonts/icon-pay-down.svg'
const ACTION = DataType.PaymentScheduleAction
const MULTI_PAYMENT_SCHEDULE_ACTION = {
  ADJUST_AMOUNT: {
    title: ACTION.ADJUST_AMOUNT.text,
    value: ACTION.ADJUST_AMOUNT.value,
    icon: 'price_change',
    isIcon: true,
    privilegeCode: DataType.PrivilegeCode.ADJUST_AMOUNT,
    buttonCode: DataType.ButtonEnum.ADJUST_AMOUNT.value,
    fieldClass: 'lg3',
    leftFields: {
      leftBalance: {
        title: 'Left Balance',
        type: DataType.PaymentFeeTypeEnum.LEFT_IN_COLLECTION.value,
        fields: [
          { label: 'Late Fee', fieldKey: 'leftLateFee', template: '{leftLateFee}' },
          { label: 'NSF Fee', fieldKey: 'leftNsfFee', template: '{leftNsfFee}' },
          { label: 'Unpaid Fee', fieldKey: 'leftUnpaidFee', template: '{leftUnpaidFee}' },
          { label: 'Finance Fee', fieldKey: 'leftInterest', template: '{leftInterest}' },
          { label: 'Principal', fieldKey: 'leftPrincipal', template: '{leftPrincipal}' }
        ]
      },
      waivedBalance: {
        title: 'Waived Balance',
        type: DataType.PaymentFeeTypeEnum.WAIVED_IN_COLLECTION.value,
        fields: [
          { label: 'Late Fee', fieldKey: 'waivedLateFee', template: '{waivedLateFee}', disabled: true },
          { label: 'NSF Fee', fieldKey: 'waivedNsfFee', template: '{waivedNsfFee}', disabled: true },
          { label: 'Unpaid Fee', fieldKey: 'waivedUnpaidFee', template: '{waivedUnpaidFee}', disabled: true },
          { label: 'Finance Fee', fieldKey: 'waivedInterest', template: '{waivedInterest}', disabled: true },
          { label: 'Principal', fieldKey: 'waivedPrincipal', template: '{waivedPrincipal}', disabled: true }
        ]
      },
      paidBalance: {
        title: 'Paid Balance',
        type: DataType.PaymentFeeTypeEnum.PAID_IN_COLLECTION.value,
        fields: [
          { label: 'Late Fee', fieldKey: 'paidLateFee', template: '{paidLateFee}', disabled: true },
          { label: 'NSF Fee', fieldKey: 'paidNsfFee', template: '{paidNsfFee}', disabled: true },
          { label: 'Unpaid Fee', fieldKey: 'paidUnpaidFee', template: '{paidUnpaidFee}', disabled: true },
          { label: 'Finance Fee', fieldKey: 'paidInterest', template: '{paidInterest}', disabled: true },
          { label: 'Principal', fieldKey: 'paidPrincipal', template: '{paidPrincipal}', disabled: true }
        ]
      }
    }
  },
  PAY_OFF_IN_N: {
    title: ACTION.PAY_OFF_IN_N.text,
    value: ACTION.PAY_OFF_IN_N.value,
    iconPath: IconPayOffInN,
    privilegeCode: DataType.PrivilegeCode.PAY_OFF_IN_N_LCS,
    buttonCode: DataType.ButtonEnum.PAY_OFF_IN_N.value,
    fieldClass: 'lg3',
    limitValue: true,
    topFields: [
      { label: 'Late Fee', fieldKey: 'lateFee', template: '{lateFee}' },
      { label: 'NSF Fee', fieldKey: 'nsfFee', template: '{nsfFee}' },
      { label: 'Unpaid Fee', fieldKey: 'unpaidFee', template: '{unpaidFee}' },
      { label: 'Finance Fee', fieldKey: 'interest', template: '{interest}' },
      { label: 'Principal', fieldKey: 'principal', template: '{principal}' }
    ],
    fields: [
      { label: 'Disbursement Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Calculation Mode', fieldKey: 'calculationMode', template: '{calculationMode}', disabled: true },
      { label: 'Installment Number', fieldKey: 'debitCount', template: '{debitCount}' },
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode } },
      { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', template: '{payrollFrequency}', controlType: 'select', items: { payrollFrequency: DataType.PayrollFrequency } },
      { label: '1st Monthly Payday', fieldKey: 'firstDayOfMonth', template: '{firstDayOfMonth}', controlType: 'select', items: { firstDayOfMonth: DataType.DayOfMonth31 } },
      { label: '2nd Monthly Payday', fieldKey: 'secondDayOfMonth', template: '{secondDayOfMonth}', controlType: 'select', items: { secondDayOfMonth: DataType.DayOfMonth31 } },
      { label: '1st Day of Week', fieldKey: 'firstDayOfWeek', template: '{firstDayOfWeek}', controlType: 'select', items: { firstDayOfWeek: DataType.FirstDayOfWeek } },
      { label: 'Payday On Holiday', fieldKey: 'paydayOnHoliday', template: '{paydayOnHoliday}', controlType: 'select', items: { paydayOnHoliday: DataType.PaydayOnHolidayType } },
      { label: 'Payday On Availiable', fieldKey: 'paydayOnAvailable', template: '{paydayOnAvailable}', controlType: 'select', items: { paydayOnAvailable: DataType.PaydayOnAvailable } }
    ]
  },
  PAY_FIXED_AMOUNT: {
    title: ACTION.PAY_FIXED_AMOUNT.text,
    value: ACTION.PAY_FIXED_AMOUNT.value,
    iconPath: IconPayOff,
    privilegeCode: DataType.PrivilegeCode.PAY_FIXED_AMOUNT,
    buttonCode: DataType.ButtonEnum.PAY_FIXED_AMOUNT.value,
    fieldClass: 'lg3',
    limitValue: true,
    topFields: [
      { label: 'Late Fee', fieldKey: 'lateFee', template: '{lateFee}' },
      { label: 'NSF Fee', fieldKey: 'nsfFee', template: '{nsfFee}' },
      { label: 'Unpaid Fee', fieldKey: 'unpaidFee', template: '{unpaidFee}' },
      { label: 'Finance Fee', fieldKey: 'interest', template: '{interest}' },
      { label: 'Principal', fieldKey: 'principal', template: '{principal}' }
    ],
    fields: [
      { label: 'Disbursement Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Calculation Mode', fieldKey: 'calculationMode', template: '{calculationMode}', disabled: true },
      { label: 'Regular Amount', fieldKey: 'regularAmount', template: '{regularAmount}', format: 'currency' },
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode } },
      { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', template: '{payrollFrequency}', controlType: 'select', items: { payrollFrequency: DataType.PayrollFrequency } },
      { label: '1st Monthly Payday', fieldKey: 'firstDayOfMonth', template: '{firstDayOfMonth}', controlType: 'select', items: { firstDayOfMonth: DataType.DayOfMonth31 } },
      { label: '2nd Monthly Payday', fieldKey: 'secondDayOfMonth', template: '{secondDayOfMonth}', controlType: 'select', items: { secondDayOfMonth: DataType.DayOfMonth31 } },
      { label: '1st Day of Week', fieldKey: 'firstDayOfWeek', template: '{firstDayOfWeek}', controlType: 'select', items: { firstDayOfWeek: DataType.FirstDayOfWeek } },
      { label: 'Payday On Holiday', fieldKey: 'paydayOnHoliday', template: '{paydayOnHoliday}', controlType: 'select', items: { paydayOnHoliday: DataType.PaydayOnHolidayType } },
      { label: 'Payday On Availiable', fieldKey: 'paydayOnAvailable', template: '{paydayOnAvailable}', controlType: 'select', items: { paydayOnAvailable: DataType.PaydayOnAvailable } }
    ]
  },
  REVOKE_ACH: {
    title: ACTION.REVOKE_ACH.text,
    value: ACTION.REVOKE_ACH.value,
    iconName: 'credit_card_off',
    privilegeCode: DataType.PrivilegeCode.REVOKE_ACH,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' }
    ]
  },
  REVOKE_WA: {
    title: ACTION.REVOKE_WA.text,
    value: ACTION.REVOKE_WA.value,
    iconName: 'swipe_left',
    privilegeCode: DataType.PrivilegeCode.REVOKE_WA,
    buttonCode: DataType.ButtonEnum.REVOKE_WA.value,
    fieldClass: 'lg3',
    limitValue: true
  },
  MANUALLY_SETUP: {
    title: ACTION.MANUALLY_SETUP.text,
    value: ACTION.MANUALLY_SETUP.value,
    iconPath: IconPayDown,
    privilegeCode: DataType.PrivilegeCode.MANUALLY_SETUP,
    buttonCode: DataType.ButtonEnum.MANUALLY_SET_UP.value,
    fieldClass: 'lg4',
    limitValue: true,
    topFields: [
      { label: 'Late Fee', fieldKey: 'lateFee', template: '{lateFee}' },
      { label: 'NSF Fee', fieldKey: 'nsfFee', template: '{nsfFee}' },
      { label: 'Unpaid Fee', fieldKey: 'unpaidFee', template: '{unpaidFee}' },
      { label: 'Finance Fee', fieldKey: 'interest', template: '{interest}' },
      { label: 'Principal', fieldKey: 'principal', template: '{principal}' }
    ],
    formFields: [
      { label: 'Disbursement Date', template: '{installmentDate}', fieldKey: 'installmentDate', format: 'date', controlType: 'v-date-picker', allowed: 'start-tomorrow no-holiday no-weekend' },
      { label: 'Payment Mode', template: '{transactionMode}', fieldKey: 'transactionMode', controlType: 'v-select', options: { transactionMode: DataType.TransactionMode } },
      { label: 'Principal', template: '{principal}', fieldKey: 'principal', format: 'currency', disabled: true },
      { label: 'Finance Fee', template: '{interest}', fieldKey: 'interest', format: 'currency', disabled: true },
      { label: 'Nsf Fee', template: '{nsfFee}', fieldKey: 'nsfFee', format: 'currency', disabled: true },
      { label: 'Late Fee', template: '{lateFee}', fieldKey: 'lateFee', format: 'currency', disabled: true },
      { label: 'Amount', template: '{amount}', fieldKey: 'amount', format: 'currency' }
    ],
    headers: [
      { text: '#', sortable: false },
      { text: 'Disbursement Date', value: 'installmentDate', sortable: false },
      { text: 'Payment Mode', value: 'transactionMode', sortable: false },
      { text: 'Principal', value: 'principal', sortable: false },
      { text: 'Finance Fee', value: 'interest', sortable: false },
      { text: 'Nsf Fee', value: 'nsfFee', sortable: false },
      { text: 'Late Fee', value: 'lateFee', sortable: false },
      { text: 'Amount', value: 'amount', sortable: false }
    ]
  }
}
const PREVIEW_TABLE_HEADER = [
  { label: '#', template: '{index}', fieldKey: 'index' },
  { label: 'DATE', template: '{transactionDateText}', fieldKey: 'transactionDateText' },
  { label: 'MODE', template: '{transactionMode}', fieldKey: 'transactionMode', options: { transactionMode: DataType.TransactionMode } },
  { label: 'STATUS', template: '{transactionType}', fieldKey: 'transactionType', options: { transactionType: DataType.TransactionTypeOptions } },
  { label: 'PRINCIPAL', template: '{principal}', fieldKey: 'principal', format: 'currency' },
  { label: 'FINANCE CHARGE', template: '{interest}', fieldKey: 'financeFee', format: 'currency' },
  { label: 'UNPAID FINANCE', template: '{unpaidFee}', fieldKey: 'unpaidFee', format: 'currency' },
  { label: 'LATE FINANCE', template: '{lateFee}', fieldKey: 'lateFee', format: 'currency' },
  { label: 'NSF FINANCE', template: '{nsfFee}', fieldKey: 'nsfFee', format: 'currency' },
  { label: 'AMOUNT', template: '{transactionAmount}', fieldKey: 'transactionAmount', format: 'currency' }
]
export { MULTI_PAYMENT_SCHEDULE_ACTION, PREVIEW_TABLE_HEADER }
